import type { App, Directive, DirectiveBinding } from 'vue';

function isPhone(el: Element, binding: any) {
    const phone = binding.value;
    if (!phone || phone.length !== 11) return phone;
    let arr = phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2').split('');
    arr.splice(3, 0, ' ');
    arr.splice(8, 0, ' ');
    const element = document.createTextNode(arr.join(''));
    el.appendChild(element);
}
const mounted = (el: Element, binding: DirectiveBinding<any>) => {
    isPhone(el, binding);
};

const phoneDirective: Directive = {
    mounted,
};

export function setupPhoneDirective(app: App) {
    app.directive('phoneDir', phoneDirective);
}

export default phoneDirective;
